module.exports = __webpack_public_path__ + "static/media/icon_wallet.241973dc.svg";